
import React from "react";

import Header from "./Header/header";
import Main from "./Main/main";



function Certificate() {
    return (
        <div>

            <Header />
            <Main />
        </div>
    );
}

export default Certificate;
